import React, {Component} from 'react'
import Nav from './nav'
import {fetchDaily, fetchDays} from "./functions";
import List from './list'

export default class Details extends Component {

    state = {
        active: false,
        price: {...this.props.price},
        nav: "daily",
        timestamps: [],
        loading:true
    }

    activateLoading =()=>{this.setState({loading:true})}

    componentWillMount() {
        this.fetchDataDaily(this.props.id)
    }

    fetchDataDaily = id => {
        this.activateLoading();
        fetchDaily(this.props.id).then(e => this.setState({
            timestamps: e.filter(ts => ts.ts > new Date().setDate(new Date().getDate() - 1)).reverse(),
            nav: "daily",
            loading:false
        }))
    };
    fetchDataDays = id => {
        this.activateLoading();
        fetchDays(id).then(e => this.setState({
            timestamps: e.reverse(),
            nav: 'days',
            loading:false
        }));
    }
    componentDidMount() {
        setTimeout(() => this.setState({active: true}), 1)
    }
    render() {
        const {buying, selling} = this.state.price
        return (
            <div
                className={`underline ${this.state.active
                ? "active"
                : ""}`}
                ref={e => this.underline = e}>
                <Nav
                    {...this.props}
                    {...this.state}
                    daily={() => this.fetchDataDaily(this.props.id)}
                    days={() => this.fetchDataDays(this.props.id)}
                    a={this.activateLoading}/>
                <div className='info'>
                    <div className="current">
                        <div>current</div>
                        <div>[B]:{buying}</div>
                        <div>[S]:{selling}</div>
                    </div>
                    <div className='history'>
                        {
                            !this.state.loading 
                            ? <List {...this.state}/>
                            :<div>fetching data...</div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/ui/item/details.js